// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

export const environment = {
  production: false,
  api_url:
    "https://z5p34jh740.execute-api.af-south-1.amazonaws.com/production/api", // https://localhost:3000/api
  firebaseConfig: {
    apiKey: "AIzaSyBSIe59Jbl3X6CT-ff2SS73nTZSYiJPoY8",
    authDomain: "umuzi-f655c.firebaseapp.com",
    projectId: "umuzi-f655c",
    storageBucket: "umuzi-f655c.appspot.com",
    messagingSenderId: "986685178882",
    appId: "1:986685178882:web:e8396e601008beab80131b",
    measurementId: "G-YMY8QBL4SB",
  },
  facebookConfig: {
    appId: "315597293295463",
  },
};
